import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import type { SupplyLight, SupplyId } from '@wwf/sdk';
import { SupplyListAvatar } from './SupplyListAvatar';

const formatPriceEur = (price: string | number | null) =>
    price != null
        ? new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: 'EUR',
          }).format(
              typeof price === 'string' ? Number.parseFloat(price) : price
          )
        : null;

export const SupplyListContent = ({
    openEditDrawer,
}: {
    openEditDrawer?: (id: SupplyId) => void;
}) => {
    const { data, error, isPending } = useListContext<SupplyLight>();

    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) return null;
    if (!data?.length) {
        return (
            <Stack p={2}>
                <Typography>No supplies found</Typography>
            </Stack>
        );
    }

    return (
        <List dense>
            {data.map(supply => (
                <RecordContextProvider key={supply.id} value={supply}>
                    <ListItem
                        disablePadding
                        sx={{
                            backgroundColor:
                                supply.enabled === false ? 'grey.100' : 'white',
                        }}
                    >
                        <ListItemButton
                            onClick={() =>
                                supply.id != null && openEditDrawer?.(supply.id)
                            }
                            alignItems="center"
                        >
                            <ListItemAvatar>
                                <SupplyListAvatar />
                            </ListItemAvatar>
                            <ListItemText
                                primary={supply.name}
                                secondary={[
                                    supply.type,
                                    formatPriceEur(supply.price ?? null),
                                    supply.target,
                                    supply.description,
                                ]
                                    .filter(Boolean)
                                    .join(' • ')}
                            />
                        </ListItemButton>
                    </ListItem>
                </RecordContextProvider>
            ))}
        </List>
    );
};
